import { useState, useRef, useEffect } from 'react';
import '../App.css';

// import clouds1 from "../img/clouds1.png";
// import clouds2 from "../img/clouds2.png";
// import clouds3 from "../img/clouds3.png";

import clouds4 from "../img/cloudx.png";
import clouds5 from "../img/cloudx2.png";

import LoadingScreen from '../LoadingScreen';



function LoadingClouds(props) {

  return (

    <div className={`loadingfadeclouds ${props.maploaded ? "loadingfadeclouds-start" : ""}`}>
      <div className='cloudloadingrect'>
        <LoadingScreen recoveryActive={!props.maploaded} />
      </div>
      {props.maploaded &&
      <div className="cloudswrapper">
        <img src={clouds4} className='loadingcloud clouds1' />
        <img src={clouds5} className='loadingcloud clouds2' />
        {/*<img src={clouds3} className='loadingcloud clouds3' />*/}
      </div>
      }
    </div>

  );
}

export default LoadingClouds;
